import { DataSourceMode, Textbox, ValidationResult } from "@mcleod/components";
import { AutogenLayoutDetentionControl } from "./autogen/AutogenLayoutDetentionControl";
import { EmailUtil, StringUtil } from "@mcleod/core";

export class DetentionControl extends AutogenLayoutDetentionControl {
    onLoad(): void {
        this.textboxEmailBilling.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult =>
            this.emailDomainValidator(this.textboxEmailBilling, mode);

        this.textboxEmailErrors.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult =>
            this.emailDomainValidator(this.textboxEmailErrors, mode);
    }

    private emailDomainValidator(textbox: Textbox, mode: DataSourceMode) {
        if (mode === DataSourceMode.SEARCH) {
            return null;
        }

        if (StringUtil.isEmptyString(textbox.text)) {
            return { component: textbox, isValid: true };
        }

        const domains = textbox.text.split(",");
        for (const domain of domains) {
            if (!EmailUtil.isValidEmail(domain.trim())) {
                return { component: textbox, isValid: false, validationMessage: "Invalid domain format. Email domains must be in the following format [abc.com,xyz.com]" }
            }
        }

        return { component: textbox, isValid: true };
    }
}
